import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sj_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetcher = (url) => api.get(url).then((r) => r.data);

export const imgUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND_URL}${u}` : u || "");

export const asList = (d) => (Array.isArray(d) ? d : []);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg || JSON.stringify(e)).replace(/^Value error, /, "")).join(" ");
  return detail?.msg || String(detail);
}
